import { v5 } from 'uuid';
const MY_NAMESPACE = '1b671a64-40d5-491e-99b0-da01ff1f3341';

export const team = [
  //
  {
    id: v5('team-photo1', MY_NAMESPACE),
    imgBigSize: './team/1b.jpg',
    imgSmallSize: './team/1s.jpg',
    title: 'Charlotte Chambers',
    category: 'Top Model',
  },
  {
    id: v5('team-photo2', MY_NAMESPACE),
    imgBigSize: './team/11b.jpg',
    imgSmallSize: './team/11s.jpg',
    title: 'Safiya Valenzuela',
    category: 'Photo Model',
  },
  {
    id: v5('team-photo3', MY_NAMESPACE),
    imgBigSize: './team/8b.jpg',
    imgSmallSize: './team/8s.jpg',
    title: 'Sally Fleming',
    category: 'Super Model',
  },
  //
  {
    id: v5('team-photo4', MY_NAMESPACE),
    imgBigSize: './team/10b.jpg',
    imgSmallSize: './team/10s.jpg',
    title: 'Kathy Walker',
    category: 'Photo Model',
  },

  {
    id: v5('team-photo5', MY_NAMESPACE),
    imgBigSize: './team/4b.jpg',
    imgSmallSize: './team/4s.jpg',
    title: 'Eleni Pritchard',
    category: 'Super Model',
  },
  {
    id: v5('team-photo6', MY_NAMESPACE),
    imgBigSize: './team/12b.jpg',
    imgSmallSize: './team/12s.jpg',
    title: 'Lucca Mckenna',
    category: 'Top Model',
  },
  //
  {
    id: v5('team-photo7', MY_NAMESPACE),
    imgBigSize: './team/7b.jpg',
    imgSmallSize: './team/7s.jpg',
    title: 'Amanda Odling',
    category: 'Photo Model',
  },

  {
    id: v5('team-photo8', MY_NAMESPACE),
    imgBigSize: './team/9b.jpg',
    imgSmallSize: './team/9s.jpg',
    title: 'Isma Odonnell',
    category: 'Top Model',
  },

  {
    id: v5('team-photo9', MY_NAMESPACE),
    imgBigSize: './team/3b.jpg',
    imgSmallSize: './team/3s.jpg',
    title: 'Alishia Cole',
    category: 'Super Model',
  },
  //
  {
    id: v5('team-photo10', MY_NAMESPACE),
    imgBigSize: './team/2b.jpg',
    imgSmallSize: './team/2s.jpg',
    title: 'Clarke Hoover',
    category: 'Top Model',
  },
  {
    id: v5('team-photo11', MY_NAMESPACE),
    imgBigSize: './team/13b.jpg',
    imgSmallSize: './team/13s.jpg',
    title: 'Adriana Davies',
    category: 'Photo Model',
  },
  {
    id: v5('team-photo12', MY_NAMESPACE),
    imgBigSize: './team/5b.jpg',
    imgSmallSize: './team/5s.jpg',
    title: 'Darnell Bond',
    category: 'Super Model',
  },
  //

  {
    id: v5('team-photo13', MY_NAMESPACE),
    imgBigSize: './team/14b.jpg',
    imgSmallSize: './team/14s.jpg',
    title: 'Margot Alford',
    category: 'Photo Model',
  },
  {
    id: v5('team-photo14', MY_NAMESPACE),
    imgBigSize: './team/6b.jpg',
    imgSmallSize: './team/6s.jpg',
    title: 'Dilan Duran',
    category: 'Super Model',
  },
  {
    id: v5('team-photo15', MY_NAMESPACE),
    imgBigSize: './team/15b.jpg',
    imgSmallSize: './team/15s.jpg',
    title: 'Mahima Ayala',
    category: 'Top Model',
  },
];
